// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3D4PR","clinicsSelect":"TableHeading_clinicsSelect__5yGDQ"};